const MILLISECOND_TIMESTAMP_THRESHOLD = 1e12

function toMilliseconds(value) {
  const timestamp = Number(value)
  if (!Number.isFinite(timestamp)) {
    return 0
  }

  return Math.abs(timestamp) < MILLISECOND_TIMESTAMP_THRESHOLD
    ? timestamp * 1000
    : timestamp
}

function getPositiveDuration(value) {
  const duration = Number(value)
  return Number.isFinite(duration) && duration > 0 ? duration : 0
}

function getStandardWindowDuration(standardExam) {
  if (!standardExam) {
    return 0
  }

  const startTime = toMilliseconds(standardExam.exam_begin_time)
  const endTime = toMilliseconds(standardExam.exam_end_time)
  return getPositiveDuration(endTime - startTime)
}

/**
 * Normalize a custom exam entry window to milliseconds.
 *
 * The close time is not editable in the UI, so a persisted non-positive
 * duration must never be reused. Recover it from the project's standard entry
 * window (or, as a last resort, the test duration) instead.
 */
export function normalizeCustomExamWindow(item = {}, standardExam = null) {
  const startTime = toMilliseconds(item.event_start_time)
  const storedEndTime = toMilliseconds(item.event_end_time)
  const explicitDuration = getPositiveDuration(item.duration)
  const storedDuration = getPositiveDuration(storedEndTime - startTime)
  const standardDuration = getStandardWindowDuration(standardExam)
  const templateDuration = getPositiveDuration(
    Number(item.template && item.template.test_duration) * 60 * 1000
  )
  // The close time is read-only, so the project schedule is authoritative.
  // Stored/explicit values are only legacy fallbacks for projects without a
  // complete standard window.
  const duration = standardDuration || explicitDuration || storedDuration || templateDuration

  return Object.assign({}, item, {
    event_start_time: startTime,
    event_end_time: startTime && duration ? startTime + duration : storedEndTime,
    duration
  })
}
